/*
 * MotoEbikes — live Google rating/count for static stat displays.
 * Fills any [data-gr-rating] / [data-gr-count] element and retargets animated
 * counters ([data-gr-rating-count]) from the canonical Google-reviews feed, so
 * these figures are never fabricated and always match the real Google profile.
 * No-ops (and never fetches) on pages that have no such hooks.
 */
(function () {
  if (!document.querySelector('[data-gr-rating],[data-gr-count],[data-gr-rating-count]')) return;

  var ENDPOINT = 'https://motoebikes-google-reviews.maleftertal.workers.dev/';
  var CACHE_KEY = 'meb_gr_stats_v1';

  function apply(d) {
    if (!d) return;
    var rating = (typeof d.rating === 'number') ? d.rating.toFixed(1)
               : (d.rating != null ? String(d.rating) : null);
    var count = d.review_count || d.reviewCount || d.user_ratings_total || null;

    if (rating) {
      document.querySelectorAll('[data-gr-rating]').forEach(function (el) { el.textContent = rating; });
      // Animated counters read their target from data-count; retarget it to the
      // live rating so the count-up lands on the real figure.
      document.querySelectorAll('[data-gr-rating-count]').forEach(function (el) {
        el.setAttribute('data-count', rating);
      });
    }
    if (count) {
      document.querySelectorAll('[data-gr-count]').forEach(function (el) { el.textContent = String(count); });
    }
  }

  // Paint instantly from a cached value (avoids a flash of the fallback figure).
  try { var cached = sessionStorage.getItem(CACHE_KEY); if (cached) apply(JSON.parse(cached)); } catch (e) {}

  fetch(ENDPOINT, { headers: { Accept: 'application/json' }, mode: 'cors' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d) return;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rating: d.rating, review_count: d.review_count })); } catch (e) {}
      apply(d);
    })
    .catch(function () {});
})();
